<template>
  <div class="table-pagination">
    <div :class="getClass">
      <slot></slot>
  </div>
    <el-pagination
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="pageSizes"
      :page-size="nSize"
      :total="total"
      :current-page="nCurrent"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :pager-count="5"
      >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'epagination',
  watch:{
    //this.$store.state.tagsView.cachedViews
    'current':function(){
      this.nCurrent=this.current;
    },
    'size':function(){
      this.nSize=this.size;
    }
  },
  computed:{
    getClass(){
      let c= 'eldivOpen eldiv'
      if(this.$store.state.app.sidebar.opened){
        c= 'eldivOpen eldiv'
      }else{
        c= 'eldivClose eldiv'
      }
      return c;
    }
  },
  props: {
    size: {
      default:25
    },
    total: {
      type: Number,
      default: 0
    },
    pageSizes: {
      type: Array,
      default:()=>{
        return [25,50,100,200]
      }
    },
    current:{
      type:Number,
      default:1
    }
  },
  data() {
    return {
      nCurrent:this.current,
      nSize:Number(this.size)
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.nCurrent = val
      this.$emit('change', this.nCurrent, this.nSize)
    },
    handleSizeChange(val) {
      console.log(val)
      this.nSize = val
      this.$emit('change', this.nCurrent, this.nSize)
    }
  }
}
</script>
<style>
  .eldiv{
    float: left;
    line-height: 33px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .eldiv > *{
    display: inline;
  }
  .eldivOpen{
    margin-left: 210px;
    max-width: calc(100% - 646px );
  }
  .eldivClose{
    margin-left: 50px;
    max-width: calc(100% - 586px );
  }
</style>
